import styled from 'styled-components'

import { DragDropWrapperStyled } from '@ui/blocks/DragDropWrapper/styles/DragDropWrapperStyled'
import { UploaderStyled } from '@ui/blocks/Uploader/styles/UploaderStyled'

interface ISingleFileViewerUploadStyledProps {}

export const SingleFileViewerUploadStyled = styled.div<ISingleFileViewerUploadStyledProps>`
  width: 100%;
  height: 100%;

  ${DragDropWrapperStyled}, ${UploaderStyled} {
    width: 100%;
    height: 100%;
  }
`
